export const chartBackgroundColors = [
  "#58B1C9",
  "#1A428A",
  "#BC426B",
  "#3366D5",
  "#EBAE07",
  "#A944C5",
  "#8BB147",
]
